export default __webpack_public_path__ + "assets/img/brac_favicon.png";